import { ApplicationId } from "@1games-ru/region-shared/dist/enums/tablet/applicationd-id";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { KeyAction } from "@/shared/ui/KeyActionPanel";
import { Tab } from "@/domains/estate/constants/tab";
import { currentTabSelector, estateSelector, setIsLocked } from "@/domains/estate/slice";
import { tabletActiveApp } from "@/domains/tablet/slice";
import closeTablet from "@/domains/tablet/helpers/closeTablet";
import useToggleLockEstate from "@/domains/estate/hooks/useToggleLockEstate.ts";
import KeyCode from "@/assets/constants/key-code";

export default function useGetActionButtons() {
  const dispatch = useAppDispatch();
  const activeApp = useAppSelector(tabletActiveApp);
  const estate = useAppSelector(estateSelector);
  const currentTab = useAppSelector(currentTabSelector);
  const { t } = useTranslation("tablet");

  const toggleLockHouse = useCallback(
    () => dispatch(setIsLocked(!estate.isLocked)),
    [dispatch, estate?.isLocked],
  );

  const { toggleLockEstate } = useToggleLockEstate();

  const myHomeActions = new Map<KeyCode, KeyAction>([
    [
      KeyCode.L,
      {
        label: estate?.isLocked
          ? t("actionButtons.myHouse.openHouse")
          : t("actionButtons.myHouse.closeHouse"),
        keyName: "L",
        action: () => toggleLockEstate(estate, toggleLockHouse),
        color: "red",
        className: "min-w-[9.1875rem]",
      },
    ],
    [
      KeyCode.ESCAPE,
      {
        label: t("actionButtons.close"),
        keyName: "ESC",
        action: () => {},
        color: "red",
        onClick: closeTablet,
      },
    ],
  ]);

  const defaultActions = new Map<KeyCode, KeyAction>([
    [
      KeyCode.ESCAPE,
      {
        label: t("actionButtons.close"),
        keyName: "ESC",
        action: () => {},
        color: "red",
        onClick: closeTablet,
      },
    ],
  ]);

  switch (activeApp) {
    case ApplicationId.House:
      return estate && currentTab === Tab.Info ? myHomeActions : defaultActions;
    default:
      return defaultActions;
  }
}
